/**
 * Le choix de l'agrégateur, avec son feu.
 *
 * Il était une rangée de boutons en haut à droite, où un agrégateur du catalogue sans
 * moteur se signalait par un « · » à 50 % d'opacité, que personne ne savait lire. Le
 * mot est désormais écrit : « intégré » ou « générique ».
 *
 * Le feu reprend la synthèse de chaque agrégateur : vert s'il peut piloter, ambre s'il
 * lui manque une étape, gris tant qu'on ne sait pas. Il évite d'ouvrir chacun pour
 * trouver celui qui est cassé.
 */
const FEU = {
  pret: { classe: 'bg-emerald-500', texte: 'raccordé' },
  incomplet: { classe: 'bg-amber-500', texte: 'raccordement incomplet' },
  inconnu: { classe: 'bg-neutral-300', texte: 'état inconnu' },
};

export function feuDe(synthese) {
  if (!synthese) return 'inconnu';
  return synthese.peut_appeler && synthese.peut_agir && synthese.a_du_perimetre
    ? 'pret' : 'incomplet';
}

export default function SelecteurAgregateur({ agregateurs, actif, syntheses, surChoix }) {
  return (
    <div role="tablist" aria-label="Agrégateur"
         className="flex flex-wrap gap-1.5 rounded-lg border border-neutral-200 bg-neutral-50 p-1">
      {agregateurs.map((a) => {
        const feu = FEU[feuDe(syntheses[a.cle])];
        const choisi = a.cle === actif;
        return (
          <button key={a.cle} type="button" role="tab" aria-selected={choisi}
                  onClick={() => surChoix(a.cle)}
                  data-testid={`bridge-agregateur-${a.cle}`}
                  className={`flex min-w-[150px] items-center gap-2.5 rounded-md px-3 py-2
                    text-left transition-colors duration-150 focus-visible:outline-none
                    focus-visible:ring-2 focus-visible:ring-neutral-400 ${choisi
                      ? 'bg-white shadow-sm ring-1 ring-neutral-200'
                      : 'hover:bg-white/70'}`}>
            <span className={`h-2 w-2 shrink-0 rounded-full ${feu.classe}`}
                  title={feu.texte} aria-label={feu.texte} />
            <span>
              <span className="block text-[13.5px] font-medium text-neutral-900">{a.label}</span>
              <span className="block text-[11.5px] text-neutral-500">
                {a.integre === false ? 'générique' : 'intégré'}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
